import type { EditorView } from "prosemirror-view";

// Scroll the article container, not the window: split view has two panes and window.scrollTo moves the wrong one.

const VIEWPORT_SHARE = 3;

export const scrollableParent = (element: HTMLElement | null): HTMLElement | null => {
	for (let node = element?.parentElement; node; node = node.parentElement) {
		const { overflowY } = getComputedStyle(node);
		const scrollable = overflowY === "auto" || overflowY === "scroll";
		if (scrollable && node.scrollHeight > node.clientHeight) return node;
	}
	return null;
};

const scrollToDiff = (view: EditorView, target: number | HTMLElement) => {
	const coords =
		typeof target === "number"
			? view.coordsAtPos(Math.max(0, Math.min(target, view.state.doc.content.size)))
			: target.getBoundingClientRect();
	const container = scrollableParent(view.dom);

	if (!container) {
		window.scrollTo({ top: window.scrollY + coords.top - window.innerHeight / VIEWPORT_SHARE, behavior: "smooth" });
		return;
	}

	const box = container.getBoundingClientRect();
	const top = container.scrollTop + coords.top - box.top - container.clientHeight / VIEWPORT_SHARE;
	container.scrollTo({ top, behavior: "smooth" });
};

export default scrollToDiff;
